import React from 'react'
import { LuCircleAlert } from 'react-icons/lu'

import ImportErrorMessage from '@/components/misc/ImportReferrals/ImportErrorMessage'
import { Alert, AlertDescription } from '@/components/ui/alert'
import useAppSelector from '@/hooks/useAppSelector'
import { useCurrentCompany } from '@/hooks/useCurrentCompany'
import { DOM_IDS } from '@/lib/constants'
import { selectLogHistoricalReferralState } from '@/redux/slices/logHistoricalReferral'

const LogReferralErrors: React.FC = () => {
  const referralLogHistoricalState = useAppSelector(
    selectLogHistoricalReferralState,
  )
  const currentCompany = useCurrentCompany()

  if (!referralLogHistoricalState.logErrors) {
    return null
  }

  const importItem =
    referralLogHistoricalState.logData.referralDirection === 'TO'
      ? {
          importingCompany: currentCompany,
          fromCompany: currentCompany,
          toCompany: referralLogHistoricalState.logData.otherCompany,
          sourceClientEmail: referralLogHistoricalState.logData.newClientEmail,
        }
      : {
          importingCompany: currentCompany,
          fromCompany: referralLogHistoricalState.logData.otherCompany,
          toCompany: currentCompany,
          sourceClientEmail: referralLogHistoricalState.logData.newClientEmail,
        }

  return (
    <Alert
      variant="destructive"
      className="mb-4 border-destructive"
      id={DOM_IDS.logReferralErrorBox}
    >
      <AlertDescription>
        {referralLogHistoricalState.logErrors ? (
          <>
            <p className="flex items-start gap-2 mb-3 leading-normal!">
              <LuCircleAlert className="mt-1" />
              <span>
                The following errors prevented the referral from being logged:
              </span>
            </p>

            <ul className="ml-3">
              {Object.entries(referralLogHistoricalState.logErrors).map(
                ([key, value], index) => (
                  <li key={`${index}-${key}-${value}`}>
                    <ImportErrorMessage
                      importItem={importItem}
                      field={key}
                      message={value}
                    />
                  </li>
                ),
              )}
            </ul>
          </>
        ) : (
          <p className="mb-4">Unknown error</p>
        )}
      </AlertDescription>
    </Alert>
  )
}

export default LogReferralErrors
